import styled, { css, StyledProps } from 'styled-components'

interface TextProps {
  align?: 'left' | 'center' | 'right'
  size?: 'sm' | 'md' | 'lg'
  type?: 'warn'
}

const cssOfSize = (props: StyledProps<TextProps>) => {
  const { size = 'lg' } = props
  if (size === 'sm') {
    return css`
      font-size: ${(p) => p.theme.font.size.s};
      line-height: 18px;
    `
  }

  if (size === 'md') {
    return css`
      font-size: ${(p) => p.theme.font.size.m};
      line-height: 21px;
    `
  }

  return css`
    font-size: ${(p) => p.theme.font.size.m};
    line-height: 24px;
  `
}

const cssOfType = (props: StyledProps<TextProps>) => {
  const { type = '' } = props
  return css`
    color: ${(p) =>
      type === 'warn' ? p.theme.ERROR_FONT_COLOR : p.theme.FONT_COLOR};
  `
}

const Text = styled.p<TextProps>`
  margin: 0;
  text-align: ${(p) => (p.align ? p.align : 'left')};
  ${cssOfSize}
  ${cssOfType}
`

export default Text
